import { supabase } from "@/integrations/supabase/client";

const MAX_UPLOAD_SIZE = 5 * 1024 * 1024; // 5 MB
const MAX_MEDIA_SIZE = 20 * 1024 * 1024; // 20 MB for video/audio
const ALLOWED_EXTENSIONS = new Set(["jpg", "jpeg", "png", "gif", "webp"]);

export async function uploadMessageAttachment(file: File) {
  const ext = (file.name.split(".").pop() || "").toLowerCase();

  if (!ALLOWED_EXTENSIONS.has(ext)) {
    return { publicUrl: null, error: new Error("File type not allowed. Use JPG, PNG, GIF, or WebP.") };
  }
  if (file.size > MAX_UPLOAD_SIZE) {
    return { publicUrl: null, error: new Error("File too large. Maximum size is 5 MB.") };
  }

  const path = `${crypto.randomUUID()}.${ext}`;

  const { error } = await supabase.storage
    .from("message-attachments")
    .upload(path, file);

  if (error) {
    return { publicUrl: null, error };
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from("message-attachments").getPublicUrl(path);

  return { publicUrl, error: null };
}

export async function uploadMediaAttachment(blob: Blob, type: "video" | "audio") {
  const ext = type === "video" ? "webm" : "webm";
  const contentType = type === "video" ? "video/webm" : "audio/webm";

  if (blob.size > MAX_MEDIA_SIZE) {
    return { publicUrl: null, error: new Error(`File too large. Maximum size is 20 MB.`) };
  }

  const path = `${crypto.randomUUID()}.${ext}`;

  const { error } = await supabase.storage
    .from("message-attachments")
    .upload(path, blob, { contentType });

  if (error) {
    return { publicUrl: null, error };
  }

  const {
    data: { publicUrl },
  } = supabase.storage.from("message-attachments").getPublicUrl(path);

  return { publicUrl, error: null };
}
